import styled from "styled-components";
import { STYLE_CONSTS } from "~/src/styles/config.style";

export const Disabled = styled.div`
  font-size: ${STYLE_CONSTS.FONT_MEDIUM};
  color: ${({ theme }) => theme.text.primary};
  min-height: ${STYLE_CONSTS.UNIT_5};
`;
